module.exports = __webpack_public_path__ + "static/mob-5f80d4c414e1f4c0a63124b361273be5.svg";